module.exports = __webpack_public_path__ + "static/media/sharepoint.5788649e.svg";